export default (props, vars) => props?.['disabled'] && 'disabled';
